export default __webpack_public_path__ + "static/media/r2u-logo.ed09606c.svg";